import { z } from '@/lib/zod'

export const NewsSchema = z
  .object({
    content: z.string().optional().nullable(),
    postExternalUrl: z.string().optional().nullable(),
    postFile: z.instanceof(File).optional().nullable(),
  })
  .refine((data) => data.content || data.postExternalUrl || data.postFile)

export type NewsForm = z.infer<typeof NewsSchema>
